export default {
  SYSTEMADMIN: "systemAdmin",
  COMPANYADMIN: "companyAdmin",
  USER: "user",
  PIPELINEGUEST: "pipelineGuest",
  GUEST: "guest"
};
